import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
    selector: 'app-footer',
    imports: [RouterLink],
    template: `
    <footer class="footer">
      <img src="../assets/images/img_logo_finsinfo_1.png" alt="FINSINFO Logo" class="footer-logo">
      <div class="footer-row">
        <p class="copyright">© Copyright 2012 - 215.449 - All Rights Reserved</p>
        <div class="social-icons">
          <a href="https://instagram.com/finsinfo" target="_blank">
            <img src="../assets/images/img_icons8instagram96_1.png" alt="Instagram" class="social-icon">
          </a>
          <a href="https://linkedin.com/company/finsinfo" target="_blank">
            <img src="../assets/images/img_icons8linkedin96_1.png" alt="LinkedIn" class="social-icon">
          </a>
          <a href="https://facebook.com/finsinfo" target="_blank">
            <img src="../assets/images/img_icons8facebook96_1.png" alt="Facebook" class="social-icon">
          </a>
          <a title="Administrador" class="social-icon ri--admin-fill" (click)="onLogin($event)">
          </a>
        </div>
      </div>
    </footer>
  `,
    styles: [
      `
      .footer {
        background-color: #2a408b;
        padding: 40px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .footer-logo {
        width: 409.36px;
        height: auto;
        margin-bottom: 40px;
      }

      .footer-row {
        width: 100%;
        max-width: 900px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .social-icons {
        display: flex;
        gap: 20px;
      }

      .social-icon {
        width: 55px;
        height: 55px;
        transition: transform 0.3s ease;
      }

      .social-icon:hover {
        transform: scale(1.1);
      }

      .copyright {
        font-size: 25px;
        font-weight: 500;
        line-height: 31px;
        color: #ffffff;
        margin: 0;
      }

      .ri--admin-fill {
        display: inline-block;
        cursor: pointer;
        width: 55px;
        height: 55px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M12 14v8H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m9 4h1v5h-8v-5h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z' stroke-width='0.5' stroke='%2319326B'/%3E%3C/svg%3E");
      }

      @media (max-width: 576px) {
        .footer {
          padding: 20px 5px;
        }
        
        .footer-logo {
          width: 140px;
          margin-bottom: 18px;
        }
        
        .footer-row {
          flex-direction: column;
          gap: 12px;
          align-items: center; /* Cambiado a center */
          max-width: 100vw;
        }

        .copyright {
          font-size: 12px;
          line-height: 16px;
          text-align: center; /* Centrado */
          width: 100%;        /* Ocupar todo el ancho */
        }

        .social-icons {
          gap: 10px;
          align-self: center; /* Centrado */
          justify-content: center; /* Centrado */
          width: 100%;
          display: flex;
        }

        .social-icon,
        .ri--admin-fill {
          width: 32px;
          height: 32px;
        }

        .ri--admin-fill {
          display: none !important; /* Oculta el icono admin */
        }
      }

      @media (max-width: 600px) {
        .footer-row {
          flex-direction: column;
          gap: 20px;
          align-items: flex-start;
        }
        
        .social-icons {
          align-self: flex-end;
        }
      }
      `,
    ]
})
export class FooterComponent {
  constructor(private router: Router) {}

   onLogin(event: Event) {
  event.preventDefault();
 // Scroll al tope de la página
  this.router.navigate(['/auth/adminLogin']).then(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
}
